module.exports = __webpack_public_path__ + "img/map-marker-icon-red.f2569421.png";